<template>
        <button class="btn btn-primary btn-domain" type="button" @click="disciplineClicked($event)">
            <slot></slot>
        </button>
</template>

<script>
    export default {
        name: "design-2021-digitalstudies-subject-button",
        methods: {
            disciplineClicked(event) {
                this.$emit('selectedDiscipline', event.currentTarget.name);
            }
        }
    }
</script>

<style scoped lang="scss">
    .btn-domain {
        padding: map-get($grid-gutter-spacing, 'ten');
        margin-right: map-get($grid-gutter-spacing, 'fifteen');
        margin-bottom: map-get($grid-gutter-spacing, 'fifteen');
    }

    @media (min-width: 992px) {
        .btn-domain {
            padding: 0;
            margin-right: 30px;
            margin-bottom: 30px;
            min-width: 115px;
        }
    }

</style>
